import CommitmentCleanEnergy from "Assets/Common/Commitments/CleanEnergy.png";
import CommitmentCleanWater from "Assets/Common/Commitments/CleanWater.png";
import CommitmentClimateAction from "Assets/Common/Commitments/ClimateAction.png";
import CommitmentDecentWork from "Assets/Common/Commitments/DecentWork.png";
import CommitmentGenderEquality from "Assets/Common/Commitments/GenderEquality.png";
import CommitmentGoodHealth from "Assets/Common/Commitments/GoodHealth.png";
import CommitmentIndustry from "Assets/Common/Commitments/Industry.png";
import CommitmentLifeBelowWater from "Assets/Common/Commitments/LifeBelowWater.png";
import CommitmentLifeOnLand from "Assets/Common/Commitments/LifeOnLand.png";
import CommitmentNoPoverty from "Assets/Common/Commitments/NoPoverty.png";
import CommitmentPartnership from "Assets/Common/Commitments/Partnerships.png";
import CommitmentPeaceJustice from "Assets/Common/Commitments/PeaceJustice.png";
import CommitmentQualityEducation from "Assets/Common/Commitments/QualityEducation.png";
import CommitmentReducedInequalities from "Assets/Common/Commitments/ReducedInequalities.png";
import CommitmentResponsibleConsumption from "Assets/Common/Commitments/ResponsibleConsumption.png";
import CommitmentSustainableCities from "Assets/Common/Commitments/SustainableCities.png";
import CommitmentZeroHunger from "Assets/Common/Commitments/ZeroHunger.png";

import * as S from "./styles";

const Commitments = ({ commitments, setCommitments, variant = "dark" }) => {
  const isSelected = (commitment) => commitments.includes(commitment);

  const selectOrUnselectCommitment = (commitment) => {
    if (isSelected(commitment)) {
      setCommitments(commitments.filter((c) => c !== commitment));
    } else {
      setCommitments([...commitments, commitment]);
    }
  };

  const defaultCommitments = [
    {
      src: CommitmentNoPoverty,
      name: "NoPoverty",
      alt: "Compromisso de erradicação da pobreza",
    },
    {
      src: CommitmentZeroHunger,
      name: "ZeroHunger",
      alt: "Compromisso de fome zero",
    },
    {
      src: CommitmentGoodHealth,
      name: "GoodHealth",
      alt: "Compromisso de saúde e bem-estar",
    },
    {
      src: CommitmentQualityEducation,
      name: "QualityEducation",
      alt: "Compromisso de educação de qualidade",
    },
    {
      src: CommitmentGenderEquality,
      name: "GenderEquality",
      alt: "Compromisso de igualdade de gênero",
    },
    {
      src: CommitmentCleanWater,
      name: "CleanWater",
      alt: "Compromisso de água limpa e saneamento",
    },
    {
      src: CommitmentCleanEnergy,
      name: "CleanEnergy",
      alt: "Compromisso de energia limpa e acessível",
    },
    {
      src: CommitmentDecentWork,
      name: "DecentWork",
      alt: "Compromisso de trabalho decente e crescimento econômico",
    },
    {
      src: CommitmentIndustry,
      name: "Industry",
      alt: "Compromisso de indústria, inovação e infraestrutura",
    },
    {
      src: CommitmentReducedInequalities,
      name: "ReducedInequalities",
      alt: "Compromisso de redução das desigualdades",
    },
    {
      src: CommitmentSustainableCities,
      name: "SustainableCities",
      alt: "Compromisso de cidades e comunidades sustentáveis",
    },
    {
      src: CommitmentResponsibleConsumption,
      name: "ResponsibleConsumption",
      alt: "Compromisso de consumo e produção responsáveis",
    },
    {
      src: CommitmentClimateAction,
      name: "ClimateAction",
      alt: "Compromisso de ação contra a mudança global do clima",
    },
    {
      src: CommitmentLifeBelowWater,
      name: "LifeBelowWater",
      alt: "Compromisso de vida na água",
    },
    {
      src: CommitmentLifeOnLand,
      name: "LifeOnLand",
      alt: "Compromisso de vida terrestre",
    },
    {
      src: CommitmentPeaceJustice,
      name: "PeaceJustice",
      alt: "Compromisso de paz, justiça e instituições eficazes",
    },
    {
      src: CommitmentPartnership,
      name: "Partnership",
      alt: "Compromisso de parcerias e meios de implementação",
    },
  ];

  return (
    <S.Wrapper variant={variant}>
      <label>
        Compromissos - Objetivos de Desenvolvimento Sustentável (ODS)
      </label>
      <S.Commitments>
        {defaultCommitments.map((commitment) => (
          <S.Commitment
            key={commitment.name}
            src={commitment.src}
            alt={commitment.alt}
            onClick={() => selectOrUnselectCommitment(commitment.name)}
            selected={isSelected(commitment.name)}
            variant={variant}
          />
        ))}
      </S.Commitments>
    </S.Wrapper>
  );
};

export default Commitments;
